import { type UseModalState } from "@clipboard-health/ui-react";
import { Stack } from "@mui/material";
import { type RecentlyVisitedPage } from "@src/appV2/lib/utils/useRecentlyVisited";

import { Button } from "../../components/Button";
import { Dialog } from "../../components/Dialog";

interface RecentlyViewedDialogProps {
  modalState: UseModalState;
  recentVisited: RecentlyVisitedPage[] | undefined;
  onUserClicked: (recentlyVisitedPage: RecentlyVisitedPage) => void;
}

export function RecentlyViewedDialog(props: RecentlyViewedDialogProps) {
  const { modalState, recentVisited, onUserClicked } = props;

  if (!recentVisited) {
    return null;
  }

  return (
    <Dialog
      showCloseButton
      modalState={modalState}
      title="Recently Viewed Accounts"
      width={600}
      sx={{
        "& .MuiDialog-paper": {
          maxHeight: "60vh",
          minHeight: "25vh",
        },
      }}
    >
      <Stack spacing={3}>
        {recentVisited.map((item) => (
          <Button
            key={item.id}
            fullWidth
            variant="outlined"
            endIconType="hyperlink"
            onClick={() => {
              modalState.closeModal();
              onUserClicked(item);
            }}
          >
            {item.title}
          </Button>
        ))}
      </Stack>
    </Dialog>
  );
}
